import React from "react";
import CountUp from "react-countup";

export default function ReviewDiv() {
  // Generate random dynamic values for each refresh
  // const yearsOfExperience = Math.floor(Math.random() * 3 + 3); // Random between 3 and 6
  const happyClients = Math.floor(Math.random() * 50 + 100); // Random between 100 and 150+
  const technicalExperts = Math.floor(Math.random() * 20 + 40); // Random between 40 and 60+
  const projectsDelivered = Math.floor(Math.random() * 100 + 150); // Random between 150 and 250+

  return (
    <div className="container-fluid bg-dark text-white" id="im">
      <div className="row">
        <div className="col-sm-3">
          <h1 id="br">
            13+
            {/* <CountUp start={0} end={yearsOfExperience} duration={2} />+ */}
          </h1>
          <p id="mix">Years Of Experience</p>
        </div>
        <div className="col-sm-3">
          <h1 id="br">
            <CountUp start={0} end={happyClients} duration={2} />+
          </h1>
          <p id="mix">Happy Clients</p>
        </div>
        <div className="col-sm-3">
          <h1 id="br">
            <CountUp start={0} end={technicalExperts} duration={2} />+
          </h1>
          <p id="mix">Technical Experts</p>
        </div>
        <div className="col-sm-3">
          <h1 id="br">
            <CountUp start={0} end={projectsDelivered} duration={2} />+
          </h1>
          <p id="mix">Projects Delivered</p>
        </div>
      </div>
    </div>
  );
}
